export default "__VITE_ASSET__C5jW2s_m__"